<p-toast [style]="{marginTop: '41vh'}" position="top-center" key="barra"></p-toast>
<p-confirmDialog [transitionOptions]="'0ms'" key="confirmbarra" title="Notificación" appendTo="body"></p-confirmDialog>
<div class="encabezado">
	<div class="p-grid">
		<div class="p-col-5">
			<div class="p-grid">
				<div class="p-col-1">
					<!-- CDPJ -->
					<div *ngIf="excel===true && barraExpMate === undefined" style="display: inline-block">
						<button style="background-image: url(../../assets/images/iconos/077-xls_2.webp);"
							(click)="enviarSenal('Excel')" title="Descargar Excel"></button>
					</div>
					<!-- CDPJ -->
				</div>
				<div class="p-col-11" style="float: right">
					<div *ngIf="deshabilitarbotones" style="display: inline-block;">
						<div *ngIf="noNuevo!=true" style="display: inline-block">
							<button [hidden]="barraBotonesCRUD" *ngIf="botonNuevo === false" [disabled]="botonNuevo"
								style="background-image: url(../../../assets/images/iconos/nuevo.webp);"
								(click)="enviarSenal('Nuevo')" title="Nuevo"></button>
							<button [hidden]="barraBotonesCRUD" *ngIf="botonNuevo === true" [disabled]="botonNuevo"
								style="background-image: url(../../../assets/images/iconos/nuevo-d.webp);"
								(click)="enviarSenal('Nuevo')"></button>
						</div>
						<button [hidden]="barraBotonesCRUD" *ngIf="!botonGuardar" [disabled]="botonGuardar"
							style="background-image: url(../../../assets/images/iconos/guardar.webp);"
							(click)="enviarSenal('Guardar')" title="Guardar"></button>
						<button [hidden]="barraBotonesCRUD" *ngIf="botonGuardar" [disabled]="botonGuardar"
							style="background-image: url(../../../assets/images/iconos/guardar-d.webp);"
							(click)="enviarSenal('Guardar')"></button>
						<div *ngIf="noEliminar!=true" style="display: inline-block">
							<button [hidden]="barraBotonesCRUD" *ngIf="botonBorrar === false" [disabled]="botonBorrar"
								style="background-image: url(../../../assets/images/iconos/borrar.webp);"
								(click)="enviarSenal('Borrar')" title="Eliminar"></button>
							<button [hidden]="barraBotonesCRUD" *ngIf="botonBorrar === true" [disabled]="botonBorrar"
								style="background-image: url(../../../assets/images/iconos/borrar-d.webp);"
								(click)="enviarSenal('Borrar')"></button>
						</div>
						<button [hidden]="barraBotonesCRUD"
							style="background-image: url(../../../assets/images/iconos/regresar.webp);"
							(click)="enviarSenal('Cancelar')" title="Cancelar"></button>
					</div>
					<div *ngIf="!deshabilitarbotones" style="display: inline-block;">
						<div *ngIf="noNuevo!=true" style="display: inline-block">
							<button [hidden]="barraBotonesCRUD" disabled
								style="background-image: url(../../../assets/images/iconos/nuevo-d.webp);"
								(click)="enviarSenal('Nuevo')"></button>
						</div>
						<button [hidden]="barraBotonesCRUD" disabled
							style="background-image: url(../../../assets/images/iconos/guardar-d.webp);"
							(click)="enviarSenal('Guardar')" title="Guardar"></button>
						<div *ngIf="noEliminar!=true" style="display: inline-block">
							<button [hidden]="barraBotonesCRUD" disabled
								style="background-image: url(../../../assets/images/iconos/borrar-d.webp);"
								(click)="enviarSenal('Borrar')"></button>
						</div>
						<button [hidden]="barraBotonesCRUD" disabled
							style="background-image: url(../../../assets/images/iconos/regresar-d.webp);"
							(click)="enviarSenal('Cancelar')" title="Cancelar"></button>
					</div>
					<div [hidden]="barraBotonesDesplaz" *ngIf="!barraBotonesDesplaz" style="display: inline-block;
          					margin-left:20px; border-left: 0px solid #005594; height: 30px"></div>
					<div *ngIf="barraFormaPago===true || noNuevoDVF === true" style="display: inline-block">
						<div *ngIf="imprimir!==true" style="display: inline-block">
							<div style="display: inline-block; margin-left:20px; border-left: 0px solid #005594;
									height: 30px"></div>
							<button style="background-image: url(../../../assets/images/iconos/visualizar_asiento.webp);
									background-size: contain !important;" (click)="enviarSenal('AsientoVer')" title="Visualizar Asiento"></button>
							<button style="background-image: url(../../../assets/images/iconos/026-printer.webp);"
								(click)="enviarSenal('Imprimir')" title="Imprimir"></button>
							<div style="display: inline-block; margin-left:20px; border-left: 0px solid #005594;
									height: 30px"></div>
							<!--<button *ngIf="barraFormaPago===true"
									style="background-image: url(../../../assets/images/iconos/091-credit-card-2.webp);"
									(click)="enviarSenal('PagoTarjeta')" title="Pago con tarjeta de crédito"></button>-->
						</div>
					</div>
					<div *ngIf="kardex===true" style="display: inline-block">
						<button style="background-image: url(../../../assets/images/iconos/010-speed.webp);"
							(click)="enviarSenal('Kardex')" title="Visualizar Kardex"></button>
					</div>
					<div *ngIf="reporte===true" style="display: inline-block">
						<button style="background-image: url(../../../assets/images/iconos/023-pdf-1.webp);"
							(click)="enviarSenal('Reporte')" title="Visualiza lo que se va ha imprimir"></button>
					</div>
					<button *ngIf="botonExcel === true && reporte===true" style="background-image: url(../../../assets/images/iconos/077-xls_2.webp);"
				(click)="enviarSenal('Excel')" title="Descargar Excel"></button>
					<!-- CDPJ -->
					<div *ngIf="enviofrmcorreo===true" style="display: inline-block">
						<button
							style="background-image: url(../../../assets/images/iconos/107-mailbox.webp); background-size: contain !important;"
							(click)="enviarSenal('Correo')" title="Enviar Correo"></button>
					</div>
					<!-- CDPJ -->
					<div *ngIf="imprimir===true" style="display: inline-block">
						<button style="background-image: url(../../../assets/images/iconos/026-printer.webp);"
							(click)="enviarSenal('Imprimir')" title="Imprimir"></button>
					</div>
					<button [hidden]="barraBotonesDesplaz" *ngIf="!botonPrimero"
						style="background-image: url(../../../assets/images/iconos/primero.webp);"
						(click)="enviarSenal('Primero')" [disabled]="botonPrimero" title="Primero"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="botonPrimero"
						style="background-image: url(../../../assets/images/iconos/primero-d.webp);"
						(click)="enviarSenal('Primero')" [disabled]="botonPrimero"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="!botonAnterior"
						style="background-image: url(../../../assets/images/iconos/anterior.webp);"
						(click)="enviarSenal('Anterior')" [disabled]="botonAnterior" title="Anterior"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="botonAnterior"
						style="background-image: url(../../../assets/images/iconos/anterior-d.webp);"
						(click)="enviarSenal('Anterior')" [disabled]="botonAnterior"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="!botonSiguiente"
						style="background-image: url(../../../assets/images/iconos/siguiente.webp);"
						(click)="enviarSenal('Siguiente')" [disabled]="botonSiguiente" title="Siguiente"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="botonSiguiente"
						style="background-image: url(../../../assets/images/iconos/siguiente-d.webp);"
						(click)="enviarSenal('Siguiente')" [disabled]="botonSiguiente"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="!botonUltimo"
						style="background-image: url(../../../assets/images/iconos/ultimo.webp);"
						(click)="enviarSenal('Ultimo')" [disabled]="botonUltimo" title="Último"></button>
					<button [hidden]="barraBotonesDesplaz" *ngIf="botonUltimo"
						style="background-image: url(../../../assets/images/iconos/ultimo-d.webp);"
						(click)="enviarSenal('Ultimo')" [disabled]="botonUltimo"></button>
				</div>
			</div>
		</div>
		<div class="p-col-3">
			<button *ngIf="barraBotones3 === false" [hidden]="barraBotones3"
				style="background-image: url(../../../assets/images/iconos/exportar.webp);"
				(click)="enviarSenal('Exportar')" title="Exportar"></button>
			<button *ngIf="barraBotones3 === false" [hidden]="barraBotones3"
				style="background-image: url(../../../assets/images/iconos/importar.webp);"
				(click)="enviarSenal('Importar')" title="Importar"></button>
			<button *ngIf="barraBotones3Alt === false && botonGuardarPermanente === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/guardar.webp);"
				(click)="enviarSenal('Guardar')"></button>
			<!-- CDPJ -->
			<button *ngIf="barraBotones3Alt === false && botonCancelarPermanente === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/regresar.webp);"
				(click)="enviarSenal('Cancelar')"></button>
			<!-- CDPJ -->
			<!-- GSRF -->
			<button *ngIf="barraBotonesIMP === false && botonFolder === false" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/184-folder-10.webp);"
				(click)="enviarSenal('Listaarch')" title="Buscar archivos"></button>
			<button *ngIf="barraBotonesIMP === false && botonArchivo === false" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/212-file-1.webp); "
				(click)="enviarSenal('impdoc')" title="Importar a temporales"></button>
			<button *ngIf="barraBotonesIMP === false && botonArchivo === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/008-list-1-d.webp); "
				(click)="enviarSenal('impdoc')" [disabled]="botonArchivo" title="Importar a temporales"></button>
			<!-- GSRF -->
			<button *ngIf="barraBotones3Alt === false && botonVisto === false" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/visto.webp); border-radius: 20px"
				(click)="enviarSenal('Visto')"></button>
			<button *ngIf="barraBotones3Alt === false && botonVisto === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/visto-d.webp); border-radius: 20px"
				(click)="enviarSenal('Visto')" [disabled]="botonVisto"></button>

			<button *ngIf="barraBotones3Alt === false && botongeneracuo === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/009-cash-8.webp);" (click)="enviarSenal('Generar')"
				title="Generar"></button>	
			<button *ngIf="barraBotones3Alt === false && botonreversacuo === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/cancel.webp);" (click)="enviarSenal('Reversar')"
				title="Reversar"></button>

			<button *ngIf="barraBotones3Alt === false && botonReversar === false" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/055-folder-34.webp);"
				(click)="enviarSenal('Reversar')"></button>
			<button *ngIf="barraBotones3Alt === false && botonReversar === true" [hidden]="barraBotones3Alt"
				style="background-image: url(../../../assets/images/iconos/055-folder-34-d.webp);"
				(click)="enviarSenal('Reversar')" [disabled]="botonReversar"></button>
			<div *ngIf="barraFactura === false || barraPedido === false || barraOrden === false ||
			barraGre === false || barraFacturaPro === false || barraNotasRecepcion === false || 
			barraOrdenProd === false || barraPtoVta === false" [hidden]="barraFactura"
				style="display: inline-block; margin-left:20px; border-left: 0px solid #005594; height: 30px"></div>
			<button *ngIf="barraFactura === false || barraPedido === false || barraGre === false"
				style="background-image: url(../../../assets/images/iconos/024-message.webp);"
				(click)="enviarSenal('ClaseNumeracion')" title="Remover Clase Numeración"></button>
			<button *ngIf="barraOrdenProd === false"
				style="background-image: url(../../../assets/images/iconos/024-message.webp);"
				(click)="enviarSenal('ClaseNumeracion')" title="Quitar Grupo"></button>
			<button *ngIf="botonAnular === false && (barraFactura === false || barraPedido === false || barraOrden === false ||
			 barraGre === false || barraFacturaPro === false || barraNotasRecepcion === false || barraCxpPagoDoc === false ||
			 barraCartera === false || barraConEncasil === false || barraCxpTrnCobro === false || barraOrdenProd === false ||
			 barraPtoVta === false || botonAnularPermanente === false)" style="background-image: url(../../../assets/images/iconos/077-delete.webp);"
				(click)="enviarSenal('Anular')" title="Anular" [disabled]="botonAnular"></button>
			<button *ngIf="botonAnular === true"
				style="background-image: url(../../../assets/images/iconos/077-delete_d.webp);"
				(click)="enviarSenal('Anular')" title="Anular" [disabled]="botonAnular"></button>
			<button *ngIf="barraOrdenProd === false"
				style="background-image: url(../../../assets/images/iconos/importar.webp);"
				(click)="enviarSenal('IngresarProducto')" title="Ingresar el Producto Terminado"></button>
			<button *ngIf="barraBandejaPago === true"
				style="background-image: url(../../../assets/images/iconos/072-keys.webp);"
				(click)="enviarSenal('Aprobar')" title="Aprobar"></button>
			<button *ngIf="barraBandejaPago === true"
				style="background-image: url(../../../assets/images/iconos/010-list.webp);"
				(click)="enviarSenal('GenerarArchivo')" title="Generar Archivo"></button>
			<button *ngIf="barraBandejaPago === true"
				style="background-image: url(../../../assets/images/iconos/011-checklist.webp);"
				(click)="enviarSenal('CashMng')" title="Aprobar"></button>
			<div *ngIf="barraFactura === false  || barraFacturaPro === false || barraPtoVta === false"
				[hidden]="barraFactura" style="display: inline-block;
           			margin-left:10px; border-left: 0px solid #005594; height: 30px"></div>
			<button *ngIf="barraFactura === false || barraDevolucion === false|| barraFacturaPro === false || 
				barraNotasRecepcion === false || barraPtoVta === false" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/059-discount.webp); border-radius: 20px"
				(click)="enviarSenal('Descuento')" title="Descuento Global"></button>
			<button *ngIf="(barraFactura === false || barraDevolucion === false|| barraFacturaPro === false ||
				 barraPtoVta === false) && botonPago === false" [hidden]="barraFactura" [disabled]="botonPago"
				style="background-image: url(../../../assets/images/iconos/157-money.webp);"
				(click)="enviarSenal('Pago')" title="Pago al Contado"></button>
			<button *ngIf="botonPago === true" [hidden]="barraFactura" [disabled]="botonPago"
				style="background-image: url(../../../assets/images/iconos/157-money_d.webp);"
				(click)="enviarSenal('Pago')" title="Pago al Contado"></button>
			<button
				*ngIf="(barraFactura === false || barraFacturaPro === false || barraPtoVta === false) && botonPagoCredito === false"
				[hidden]="barraFactura" style="background-image: url(../../../assets/images/iconos/085-creditcard.webp);"
				[disabled]="botonPagoCredito" (click)="enviarSenal('Credito')" title="Pago a Crédito"></button>
			<button *ngIf=" botonPagoCredito === true" [hidden]="barraFactura" [disabled]="botonPagoCredito"
				style="background-image: url(../../../assets/images/iconos/085-creditcard_d.webp);"
				(click)="enviarSenal('Credito')" title="Pago a Crédito"></button>
			<button *ngIf="check === true" [hidden]="!check"
				style="background-image: url(../../../assets/images/iconos/visto.webp);" (click)="enviarSenal('Generar')"
				title="Generar las cuotas"></button>
			<button *ngIf="check === false" [hidden]="check"
				style="background-image: url(../../../assets/images/iconos/visto-d.webp);"
				(click)="enviarSenal('Generar')" title="Generar las cuotas" disabled></button>
			<div *ngIf="barraFacturaPro === false"
				style="display: inline-block; margin-left:20px; border-left: 0px solid #005594; height: 30px"></div>
			<button *ngIf="barraFacturaPro === false"
				style="background-image: url(../../../assets/images/iconos/cogwheel.webp);"
				(click)="enviarSenal('ActualizarPrecios')" title="Actualización de Precios"></button>
			<button *ngIf="barraFacturaPro === false"
				style="background-image: url(../../../assets/images/iconos/094-cd.webp); display: none"
				(click)="enviarSenal('ActualizarDescuentos')" title="Actualizar Descuentos"></button>
			<button *ngIf="barraTransferencia === false && botonAutorizar === true"
				style="margin-left: 25%; background-image: url(../../../assets/images/iconos/072-keys.webp)"
				(click)="enviarSenal('Autorizar')" title="Autorizar"></button>
			<button *ngIf="barraTransferencia === false && botonAutorizar === false" disabled
				style="margin-left: 25%; background-image: url(../../../assets/images/iconos/072-keys_d.webp)"
				(click)="enviarSenal('Autorizar')" title="Autorizar"></button>
			<button *ngIf="barraTransferencia === false"
				style="background-image: url(../../../assets/images/iconos/062-transfer.webp)"
				(click)="enviarSenal('Transferir')" title="Transferir/Reversar"></button>
			<div *ngIf="kardex===true" style="display: inline-block">
				<button style="background-image: url(../../../assets/images/iconos/buscar.webp);"
					(click)="enviarSenal('Buscar')" title="Visualizar Kardex"></button>
			</div>
			<ng-container *ngIf="botonCabInpRent">
				<button [hidden]="!botonGenexml" style="background-image: url(../../../assets/images/iconos/i2.webp);"
					(click)="enviarSenal('gxml')" title="Generar archivo XML"></button>
				<button [hidden]="!botonRecImpRen" style="background-image: url(../../../assets/images/iconos/i3.webp);"
					(click)="enviarSenal('rimrent')" title="Recalcular Impuesto a la Renta"></button>
				<div style="display: inline-block; margin-left:20px; border-left: 0px solid #005594;
				height: 30px"></div>
				<button [hidden]="!botonCamLiq"
					style="background-image: url(../../../assets/images/iconos/212-file-1.webp);"
					(click)="enviarSenal('camliq')" title="Cambiar a liquidado"></button>
				<button [hidden]="!botonRevEstLiq"
					style="background-image: url(../../../assets/images/iconos/012-stop.webp);"
					(click)="enviarSenal('reesliq')" title="Reversar Estado Liquidación"></button>
			</ng-container>
			<ng-container *ngIf="btnLiqBenSoc">
				<button [hidden]="!btnConLiq" title="Confirmación Liquidación"
					style="background-image: url(../../../assets/images/iconos/visto.webp); border-radius: 20px"
					(click)="enviarSenal('ejecutarliq')"></button>
				<button [hidden]="!btnReveEstLiq"
					style="background-image: url(../../../assets/images/iconos/012-stop.webp);"
					(click)="enviarSenal('revliq')" title="Reversar Estado Liquidación"></button>
				<div style="display: inline-block; margin-left:20px; border-left: 0px solid #005594;
				height: 30px"></div>
			</ng-container>
			<button *ngIf="btnRevActFijo === false"
				style="background-image: url(../../../assets/images/iconos/borrar.webp)"
				(click)="enviarSenal('Reversar')" title="Reversar Confirmación Salida"></button>
			<button *ngIf="btnRevActFijo === true" disabled
				style="background-image: url(../../../assets/images/iconos/borrar-d.webp)"
				(click)="enviarSenal('Reversar')" title="Reversar Confirmación Salida"></button>
		</div>
		<div class="p-col-2">
			<div *ngIf="barraBotonesAsiCon === false && ( barraPedido === false || barraFactura === false
			|| barraOrden === false || barraFacturaPro === false || barraNotasRecepcion === false
			|| barraCxpPagoDoc === false || barraPtoVta === false)" [hidden]="barraBotonesAsiCon" style="display: inline-block;
		   margin-left:10px; border-left: 0px solid #005594; height: 30px"></div>
			<button *ngIf="barraOrdenProd === false" [hidden]="barraBotonesAsiCon"
				style="background-image: url(../../../assets/images/iconos/006-eraser.webp); background-size: contain !important;"
				(click)="enviarSenal('BorrarAsiento')" title="Borrar el Asiento contable"
				[disabled]="botonAsiento"></button>
			<button *ngIf="botonAsiento === false && barraCxpPagoDoc !== false" [hidden]="barraBotonesAsiCon"
				style="background-image: url(../../../assets/images/iconos/generar_asiento.webp); background-size: contain !important;"
				(click)="enviarSenal('Asiento')" title="Generar Asiento" [disabled]="botonAsiento"></button>
			<button *ngIf="botonAsiento === true  && barraCxpPagoDoc !== false" [hidden]="barraBotonesAsiCon"
				style="background-image: url(../../../assets/images/iconos/generar_asiento_d.webp); background-size: contain !important;"
				(click)="enviarSenal('Asiento')" title="Generar Asiento" [disabled]="botonAsiento"></button>
			<button *ngIf="botonAsiento === false && barraCxpPagoDoc === false" [hidden]="barraBotonesAsiCon"
				style="background-image: url(../../../assets/images/iconos/089-coin-1.webp); background-size: contain !important;"
				(click)="enviarSenal('AbonoCXC')" title="Ver abono en Cuentas por Cobrar"
				[disabled]="botonAsiento"></button>
			<button *ngIf="botonverAsiento === false" [hidden]="barraBotonesAsiCon"
				style="background-image: url(../../../assets/images/iconos/visualizar_asiento.webp); background-size: contain !important;"
				(click)="enviarSenal('AsientoVer')" title="Visualizar Asiento" [disabled]="botonverAsiento"></button>
			<button *ngIf="botonverAsiento === true" [hidden]="barraBotonesAsiCon"
				style="background-image: url(../../../assets/images/iconos/visualizar_asiento_d.webp); background-size: contain !important;"
				(click)="enviarSenal('AsientoVer')" title="Visualizar Asiento" [disabled]="botonverAsiento"></button>
			<div *ngIf="barraFactura === false || barraGre === false || barraFacturaPro === false || barraPtoVta === false"
				[hidden]="barraFactura" style="display: inline-block;
           margin-left:10px; border-left: 0px solid #005594; height: 30px"></div>
			<button *ngIf="(barraFactura === false || barraGre === false ||
					barraFacturaPro === false || barraCartera === false || barraPtoVta === false) && botonXML === false"
				[hidden]="barraFactura" [disabled]="botonXML"
				style="background-image: url(../../../assets/images/iconos/009-connect-1.webp); background-size: contain !important;"
				(click)="enviarSenal('Firmar')" title="Firmar Electrónicamente"></button>
			<button *ngIf="botonXML === true" [hidden]="barraFactura" [disabled]="botonXML"
				style="background-image: url(../../../assets/images/iconos/009-connect-1_d.webp); background-size: contain !important;"
				(click)="enviarSenal('Firmar')" title="Firmar Electrónicamente"></button>

			<button *ngIf="(barraFactura === false || barraGre === false ||
			barraFacturaPro === false || barraPtoVta === false || barraEnviarroles === false) && botonReenviarCorreo === false"
				[hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/107-mailbox.webp); background-size: contain !important;"
				(click)="enviarSenal('EnviarCorreo')" title="Enviar Correo de la factura electrónica"
				[disabled]="botonReenviarCorreo"></button>
			<button *ngIf="( barraCartera !== false && botonReenviarCorreo === true)" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/107-mailbox_d.webp); background-size: contain !important;"
				(click)="enviarSenal('EnviarCorreo')" title="Enviar Correo de la factura electrónica"
				[disabled]="botonReenviarCorreo"></button>

			<!-- CDPJ -->
			<button *ngIf="( barraCartera === false ) && botonReenviarCorreo === false" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/024-message.webp); background-size: contain !important;"
				(click)="enviarSenal('EnviarCorreo')" title="Enviar Correo de la factura electrónica"
				[disabled]="botonReenviarCorreo"></button>
			<button *ngIf="( barraCartera === false ) && botonReenviarCorreo === true" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/024-message_d.webp); background-size: contain !important;"
				(click)="enviarSenal('EnviarCorreo')" title="Enviar Correo de la factura electrónica"
				[disabled]="botonReenviarCorreo"></button>

			<button *ngIf="(barraFactura === false || barraGre === false ||
			barraFacturaPro === false || barraCartera === false || barraPtoVta === false ) && botonFrmCorreos === false"
				[hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/107-mailbox.webp); background-size: contain !important;"
				(click)="enviarSenal('FormularioCorreos')" title="Formularios del Envio de Correos"
				[disabled]="botonFrmCorreos"></button>
			<button *ngIf="botonFrmCorreos === true" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/107-mailbox_d.webp); background-size: contain !important;"
				(click)="enviarSenal('FormularioCorreos')" title="Formularios del Envio de Correos"
				[disabled]="botonFrmCorreos"></button>
			<button
				*ngIf="(barraFactura === false || barraGre === false ||
			barraFacturaPro === false || barraCartera === false || barraPtoVta === false ) && botonFrmCorreos === false && botonEditDatosCli === false"
				[hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/nuevo.webp); background-size: contain !important;"
				(click)="enviarSenal('Nuevo')" title="Formularios del Envio de Correos"
				[disabled]="botonFrmCorreos"></button>

			<button *ngIf="botonFrmCorreos === true && botonEditDatosCli === true" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/nuevo-d.webp); background-size: contain !important;"
				(click)="enviarSenal('Nuevo')" title="Formularios del Envio de Correos"
				[disabled]="botonFrmCorreos"></button>
			<!-- CDPJ -->
			<!-- GSRF -->
			<button
				*ngIf="(barraFactura === false || barraGre === false ||
						barraFacturaPro === false || barraCartera === false || barraPtoVta === false || barraEnviarroles === false) && botonvernofirmados === false "
				[hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/014-view.webp); background-size: contain !important;"
				(click)="enviarSenal('vernofirma')" title="Documentos firmados incorrectamente"
				[disabled]="botonvernofirmados"></button>
			<button *ngIf="botonvernofirmados === true" [hidden]="barraFactura"
				style="background-image: url(../../../assets/images/iconos/014-view-d.webp); background-size: contain !important;"
				(click)="enviarSenal('vernofirma')" title="Documentos firmados incorrectamente"
				[disabled]="botonvernofirmados"></button>
			<!-- GSRF -->
			<button *ngIf="barraPedido === false || barraOrden === false" [hidden]="barraPedido"
				style="background-image: url(../../../assets/images/iconos/059-discount.webp); border-radius: 20px"
				(click)="enviarSenal('Descuento')" title="Descuento Global"></button>
			<button *ngIf="barraOrden === false" [hidden]="barraOrden"
				style="background-image: url(../../../assets/images/iconos/072-keys.webp); border-radius: 20px"
				(click)="enviarSenal('Autorizar')" title="Autorizar"></button>

			<div *ngIf="kardex===true" style="display: inline-block">
				<button style="background-image: url(../../../assets/images/iconos/flash.webp);"
					(click)="enviarSenal('Rayo')" title="Visualizar Kardex"></button>
			</div>
			<ng-container *ngIf="btnLiqBenSoc">
				<button [hidden]="!botonBorrAsieCont"
					style="background-image: url(../../../assets/images/iconos/borrar-asi-cont.webp);"
					(click)="enviarSenal('borrasiescont')" title="Borrar el Asiento Contable"></button>
				<button [hidden]="!botonGenAsieCont"
					style="background-image: url(../../../assets/images/iconos/genenar-asiento.webp);"
					(click)="enviarSenal('genasiecont')" title="Generar Asiento Contable"></button>
				<button [hidden]="!botonVisAsieCont"
					style="background-image: url(../../../assets/images/iconos/visualizar-asiento.webp);"
					(click)="enviarSenal('visasiecont')" title="Visualizar Asiento Contable"></button>
				<button [hidden]="!botonGenArText"
					style="background-image: url(../../../assets/images/iconos/gene-texto.webp);"
					(click)="enviarSenal('genarchtext')" title="Generar Archivo de Texto"></button>
			</ng-container>
			<button *ngIf="botonBuscarPermanente === true"
				style="background-image: url(../../../assets/images/iconos/buscar.webp);" (click)="enviarSenal('Buscar')"
				title="Buscar"></button>
			<button *ngIf="botonExcelPermanente === true"
				style="background-image: url(../../../assets/images/iconos/077-xls_2.webp);" (click)="enviarSenal('Excel')"
				title="Excel"></button>
				
				<button *ngIf="botondistribuir === true"
				style="background-image: url(../../../assets/images/iconos/212-file-1.webp);" (click)="enviarSenal('Ponderar')"
				title="Ponderar"></button>

			<button *ngIf="botonDescargaPermanente === true"
				style="background-image: url(../../../assets/images/iconos/downloadfile2.webp);" (click)="enviarSenal('Descargar')"
				title="Descargar Demo"></button>

			<button *ngIf="botonAutorizarPermanente === true"
				style="margin-left: 25%; background-image: url(../../../assets/images/iconos/072-keys.webp)"
				(click)="enviarSenal('Autorizar')" title="Autorizar"></button>
			<!-- <button *ngIf="botonAnularPermanente === true"
				style="margin-left: 25%; background-image: url(../../../assets/images/iconos/077-delete.webp)"
				(click)="enviarSenal('Anular')" title="Anular"></button> -->

			<button *ngIf="botonactplan === true"
				style="background-image: url(../../../assets/images/iconos/genenar-asiento.webp);"
				(click)="enviarSenal('Cuentas')" title="Cuentas"></button>
			<button *ngIf="botonconsolida === true"
				style="background-image: url(../../../assets/images/iconos/visto.webp);"
				(click)="enviarSenal('Consolidar')" title="Consolidar"></button>

			<button *ngIf="botongeneraanc === true"
				style="background-image: url(../../../assets/images/iconos/visto.webp);"
				(click)="enviarSenal('Generaanc')" title="Generar Anticipos"></button>
			<button *ngIf="botonreversaanc === true"
				style="background-image: url(../../../assets/images/iconos/1-borrar_Asi.webp);"
				(click)="enviarSenal('Reversaanc')" title="Reversar Anticipos"></button>

			<button *ngIf="botongenerand === true"
				style="background-image: url(../../../assets/images/iconos/visto.webp);"
				(click)="enviarSenal('Generand')" title="Generar Notas Débito"></button>
			<button *ngIf="botonreversand === true"
				style="background-image: url(../../../assets/images/iconos/1-borrar_Asi.webp);"
				(click)="enviarSenal('Reversand')" title="Reversar Notas Débito"></button>

			<button *ngIf="botonactlispre=== true"
				style="background-image: url(../../../assets/images/iconos/visto.webp);"
				(click)="enviarSenal('Actlispre')" title="Actualizar"></button>
			<button *ngIf="botonImprimirPermanente === true"
				style="background-image: url(../../../assets/images/iconos/026-printer.webp);"
				(click)="enviarSenal('Imprimir')" title="Imprimir"></button>
			<button *ngIf="botonEstadoPermanente === true"
				style="background-image: url(../../../assets/images/iconos/flash.webp);"
				(click)="enviarSenal('Cambiarestado')" title="Cambiarestado"></button>
			<button *ngIf="botonCopOrdComPermanente === true"
				style="background-image: url(../../../assets/images/iconos/exportar.webp);"
				(click)="enviarSenal('Copiarordencom')" title="Copiarordencompra"></button>
			<button *ngIf="botonFacturaPermanente === true"
				style="background-image: url(../../../assets/images/iconos/folder3.webp);"
				(click)="enviarSenal('Facturar')" title="Facturar"></button>
			<div style="display: inline-block; margin-left:20px; border-left: 0px solid #005594;
				height: 30px"></div>
		</div>
		<div class="p-col-2">
			<div *ngIf="barraFactura === false" [hidden]="barraFactura" style="display: inline-block;
		   margin-left:10px; border-left: 0px solid #005594; height: 30px"></div>
			<button *ngIf="botonUtiProcesar === true" style="background-image: url(../../../assets/images/iconos/cogwheel.webp);"
				(click)="enviarSenal('procesar')" title="Procesar"></button>
			<button *ngIf=" botonPdf === true" style="background-image: url(../../../assets/images/iconos/023-pdf-1.webp);"
				(click)="enviarSenal('Pdf')" title="Descargar PDF"></button>
			<button *ngIf="botonPdf === false" style="background-image: url(../../../assets/images/iconos/023-pdf-1-d.webp);"
				(click)="enviarSenal('Pdf')" title="Descargar PDF"></button>
			<button *ngIf="barraCashmng === true"
				style="background-image: url(../../../assets/images/iconos/011-checklist.webp);"
				(click)="enviarSenal('generarTxt')" title="Generar Archivo de Texto"></button>
			<button *ngIf="botonBinocular !== true" [hidden]="barraBotones5"
				style="background-image: url(../../../assets/images/iconos/067-binocular.webp);"
				(click)="enviarSenal('facturasAbonadas')" title=""></button>
			<button *ngIf="botonBuscar === false" [hidden]="barraBotones5"
				style="background-image: url(../../../assets/images/iconos/buscar.webp);" (click)="enviarSenal('Buscar')"
				title="Buscar" [disabled]="botonBuscar"></button>
			<button *ngIf="botonBuscar === true" [hidden]="barraBotones5"
				style="background-image: url(../../../assets/images/iconos/buscar-d.webp);"
				(click)="enviarSenal('Buscar')" title="Buscar" [disabled]="botonBuscar"></button>
			<button *ngIf="botonIMP === undefined" [hidden]="barraBotones5"
				style="background-image: url(../../../assets/images/iconos/026-printer.webp);"
				(click)="enviarSenal('Imprimir')" title="Imprimir"></button>
			<button *ngIf="botonRecargo==false" style="background-image: url(../../../assets/images/iconos/flash.webp);"
				(click)="enviarSenal('Recarga')" title="Recargar"></button>
			<button *ngIf="botonImprimir === true"
				style="background-image: url(../../../assets/images/iconos/026-printer.webp);"
				(click)="enviarSenal('Imprimir')" title="Imprimir"></button>
			<button *ngIf="botonAlmacenardoc === true"
				style="background-image: url(../../../assets/images/iconos/folder3.webp);"
				(click)="enviarSenal('Almacenardoc')" title="Almacenar documentos"></button>
			<button style="background-image: url(../../../assets/images/iconos/salir.webp);"
			
				(click)="enviarSenal('Salir')"></button>
			
		</div>
	</div>
</div>

